export function isoStringOrNull(date: Date | null): string | null {
    if (date === null) {
        return null;
    }
    return date.toISOString();
}

export function valueOrNull<T, R>(
    value: T | null,
    cb: (value: T) => R,
): R | null {
    return value === null ? null : cb(value);
}

export function valueOrUndefined<T, R>(
    value: T | undefined,
    cb: (value: T) => R,
): R | undefined {
    return value === undefined ? undefined : cb(value);
}

export const unpackDateOrNull = (value: string | null) =>
    valueOrNull(value, (date) => new Date(date));

export interface TransformerProp {
    value: any;
}

export interface TransformerArrayProp {
    value: any[];
}

const GOOGLE_USER_CONTENT_PREFIX = "https://lh3.googleusercontent.com";
const AVATAR_URL_LENGTH_THRESHOLD = 200;

export function sanitizeAvatar(avatar: string | null): string | null {
    if (
        avatar !== null &&
        avatar.length > AVATAR_URL_LENGTH_THRESHOLD &&
        avatar.startsWith(GOOGLE_USER_CONTENT_PREFIX)
    ) {
        return null;
    }
    return avatar;
}

export const explicitBooleanTransformer = ({ value }: TransformerProp) => {
    if (value === "true") {
        return true;
    }
    if (value === "false") {
        return false;
    }
    return value;
};
